import service from '@/services/superaccess'

const document = {
  state: {
    document_modal: false
  },
  mutations: {
    updateStatusDocumentModal (state, status) {
      state.document_modal = status
    }
  },
  getters: {
    getStatusDocumentModal (context) {
      return context.document_modal
    }
  },
  actions: {
    setStatusDocumentModal (context, payload) {
      context.commit('updateStatusDocumentModal', payload)
    },
    retrieveDocuments (context, payload) {
      return service.post('/api/documents/list', context)
    },
    saveDocument (context, payload) {
      return service.post('/api/documents/create', context, { document: payload })
    },
    changeDocumentStatus (context, payload) {
      return service.patch('/api/documents/inactive', context, payload)
    },
    modifyDocument (context, payload) {
      return service.patch('/api/documents/modify', context, { document: payload })
    }
  }
}

export default document



// WEBPACK FOOTER //
// app/javascript/src/store/document.js